import { render, staticRenderFns } from "./GridTable.vue?vue&type=template&id=1a0b6f23&scoped=true"
import script from "./GridTable.vue?vue&type=script&lang=js"
export * from "./GridTable.vue?vue&type=script&lang=js"
import style0 from "./GridTable.vue?vue&type=style&index=0&id=1a0b6f23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b6f23",
  null
  
)

export default component.exports